export const ICON_HEIGHT_8 = 8

export const ICON_HEIGHT_12 = 12

export const ICON_HEIGHT_16 = 16

export const ICON_HEIGHT_24 = 24

export const ICON_HEIGHT_28 = 28

export const ICON_HEIGHT_32 = 32

export const ICON_HEIGHT_36 = 36

export const ICON_HEIGHT_40 = 40

export const ICON_HEIGHT_44 = 44

export const ICON_HEIGHT_48 = 48

export const ICON_HEIGHT_54 = 54

export const ICON_HEIGHT_64 = 64

export const ICON_HEIGHT_72 = 72

export const ICON_HEIGHT_20 = 20

export const ICON_HEIGHT_100 = 100

export const ICON_CLASS_ALIASES = {
  [ICON_HEIGHT_8]: 'size8',
  [ICON_HEIGHT_12]: 'size12',
  [ICON_HEIGHT_16]: 'size16',
  [ICON_HEIGHT_20]: 'size20',
  [ICON_HEIGHT_24]: 'size24',
  [ICON_HEIGHT_28]: 'size28',
  [ICON_HEIGHT_32]: 'size32',
  [ICON_HEIGHT_40]: 'size40',
  [ICON_HEIGHT_44]: 'size44',
  [ICON_HEIGHT_72]: 'size72',
}

export const ICON_SIZE = {
  size8: ICON_HEIGHT_8,
  size12: ICON_HEIGHT_12,
  size16: ICON_HEIGHT_16,
  size20: ICON_HEIGHT_20,
  size24: ICON_HEIGHT_24,
  size28: ICON_HEIGHT_28,
  size32: ICON_HEIGHT_32,
  size40: ICON_HEIGHT_40,
  size44: ICON_HEIGHT_44,
  size72: ICON_HEIGHT_72,
}

export const ICON_COLOR = {
  AiPrimary: 'var(--color-ai-primary)',
  ButtonBg: 'var(--button-bg)',
  CurrentColor: 'currentColor',
  FinanceAccent: 'var(--color-finance-accent)',
  Orange: 'var(--color-orange)',
  Red: 'var(--color-red)',
  SecondaryTextColor: 'var(--secondary-text-color)',
  SecondaryTextColor50: 'var(--secondary-text-color-50)',
  SecondaryTextColor70: 'var(--secondary-text-color-70)',
  Success: 'var(--color-success)',
  TextDisabledColor: 'var(--text-disabled-color)',
  White: 'var(--color-white)',
  Without: null,
}
